/* eslint-disable no-unused-vars */
import React from "react";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="flex max-w-[360px] mx-auto ">
        {/* image to change  */}

        <img
          src="/Assets/Images/404Page.png"
          alt="404_Page"
          className="object-contain w-full h-full"
        />
      </div>
      <Button onClick={() => navigate(-1)}>Previous Page</Button>
    </div>
  );
};

export default PageNotFound;
